import type { Transaction } from "@rocicorp/zero";

// Publishing takes the branch before its commits; facet writes must use that order too.
export async function lockCommitFacets(tx: Transaction, commitId: string) {
  if (tx.location === "server") {
    await tx.dbTransaction.query(
      "SELECT b.id FROM workflow_branches b JOIN workflow_commits c ON c.branch_id = b.id AND c.tenant_id = b.tenant_id WHERE c.id = $1 FOR NO KEY UPDATE OF b",
      [commitId]
    );
    await tx.dbTransaction.query("SELECT pg_advisory_xact_lock(hashtext($1))", [
      `commit-facets:${commitId}`,
    ]);
  }
}
